import { connect } from 'react-redux';
import { AppState } from '../../../types/store';
import {
  getProfileOwner,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../selectors/users';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession';
import { restrictLoggedOut } from '@wix/da-shared-react/pkg/redux/loggedout/actionCreators';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
} from '../../actions/profileOwner';
import { biClickProfileNavBar } from '../../actions/bi';
import { sectionRoutes } from '../../routes';

export default connect(
  (state: AppState) => {
    const isOwner = isCurrentUserProfileOwner(state);

    return {
      isOwner,
      giveState: getProfileOwner(state).giveState,
      profileOwnerUser: getProfileOwnerUser(state),
      isLoggedIn: getIsLoggedIn(state),
      routes: sectionRoutes.filter(route => {
        if (route.featureProtected) {
          return flagEnabled(state, route.featureProtected);
        }
        return isOwner || !route.isForOwnerOnly;
      }),
    };
  },
  dispatch => ({
    pushBadgeModal: (name, userId, title, onBadgeSent) =>
      dispatch(modalActions.pushBadgeModal(name, userId, title, onBadgeSent)),
    pushPointsModal: (userId, title) =>
      dispatch(modalActions.pushPointsModal(userId, title)),
    initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
    onLlamaBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
    onCakeBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
    restrictLoggedOut: payload => dispatch(restrictLoggedOut(payload)),
    biClickProfileNavBar: linkName => dispatch(biClickProfileNavBar(linkName)),
  })
);
